module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAAAPCAYAAAC2u9IeAAAAPElEQVRYhe3QsQ3AIADAMOD/n4EDqqx0sC+IMvc1+LReB/yZOcGcYE4wJ5gTzAnmBHOCOcGcYE4wJ5gTDo5bBBrCU9McAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/nrtb1-1.png
// module id = 66
// module chunks = 0